// extracted by mini-css-extract-plugin
module.exports = {"isSearch":"drink_isSearch__3oEYh"};